import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "../lib/api";

/**
 * Injects search-engine verification meta tags from CMS settings.
 * Rendered once at the layout level so the tag is present on every route.
 */
export default function SiteVerification() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return null;

  const google = (s.google_site_verification || "").trim();
  const bing = (s.bing_site_verification || "").trim();
  if (!google && !bing) return null;

  return (
    <Helmet>
      {google && <meta name="google-site-verification" content={google} />}
      {bing && <meta name="msvalidate.01" content={bing} />}
    </Helmet>
  );
}
